module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Bold.09ad9537.ttf";